import styled from 'styled-components'

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primaryDark};
  padding: 5px 0;
`

export const LogoWrapper = styled.div`
  padding-bottom: 30px;

  & img {
    width: 50%;
  }
`

export const Wrapper = styled.div`
  background: ${({ theme }) => `linear-gradient(to right, ${theme.colors.silverSkyLight}, ${theme.colors.silverSky})`};
  overflow: auto;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  @media screen and (max-width: 700px) {
    height: auto;
  }
`

export const About = styled.div`
  max-width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin: 0;
  background: ${({ theme }) =>
    `linear-gradient(to bottom, ${theme.colors.primaryDark}, ${theme.colors.secondaryDark})`};

  @media screen and (max-width: 900px) {
    display: none;
  }
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 700px;
`

export const LineWithText = styled.div`
  width: 100%;
  text-align: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.silverDark}`};
  line-height: 0.1em;
  margin: 30px 0;
  font-weight: 600;

  & > span {
    color: ${({ theme }) => theme.colors.blackLight};
    background: ${({ theme }) => theme.colors.whiteLight};
    padding: 0 10px;
  }
`

export const Social = styled.div`
  display: flex;
  justify-content: space-around;
`

export const SVGBackground = styled.img`
  position: absolute;
  opacity: 0.2;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  transform: ${({ rotate }) => `rotate(${rotate}deg)`};
`

export const ActionLink = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primaryDark};
  font-weight: 600;
`
